<template>
  <el-container class="home-container">
    <el-header>
      <div class='header_container'>
        <img src="../../assets/党徽.png" />
        <div style=" font-size: 28px">
          五微智慧党建平台
        </div>
      </div>
      <div style="float: right; font-size: 12px">
        <el-dropdown>
          <i class="el-icon-setting" style="margin-right: 10px"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-s-custom"
              @click.native="myindexDialogvVisablle = true">个人中心</el-dropdown-item>
            <el-dropdown-item icon="el-icon-unlock" @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span>{{ basicInfo.fullName }}</span>
      </div>
      <el-dialog title="个人信息维护" :visible.sync="myindexDialogvVisablle" width="30%">
        <el-form :model="basicInfo" label-width="80px">
          <el-form-item label="工号/学号:" prop="username">
            <el-input v-model="basicInfo.username" v-if="seen"></el-input>
            <span style="margin-left: 10px" v-else>{{ basicInfo.username }}</span>
          </el-form-item>
          <el-form-item label="用户姓名:" prop="fullName">
            <el-input v-model="basicInfo.fullName" v-if="seen"></el-input>
            <span style="margin-left: 10px" v-else>{{ basicInfo.fullName }}</span>
          </el-form-item>
          <el-form-item label="手机号码:" prop="mobile">
            <el-input v-model="basicInfo.mobile" v-if="seen"></el-input>
            <span style="margin-left: 10px" v-else>{{ basicInfo.mobile }}</span>
          </el-form-item>
          <el-form-item label="对应班级:" prop="banji">
            <el-input v-model="basicInfo.banji" v-if="seen"></el-input>
            <span style="margin-left: 10px" v-else>{{ basicInfo.banji }}</span>
          </el-form-item>
          <el-form-item label="出生日期:" prop="birth">
            <el-input v-model="basicInfo.birth" v-if="seen"></el-input>
            <span style="margin-left: 10px" v-else>{{ basicInfo.birth }}</span>
          </el-form-item>
          <el-form-item label="证件号:" prop="identity">
            <el-input v-model="basicInfo.identity" v-if="seen"></el-input>
            <span style="margin-left: 10px" v-else>{{ basicInfo.identity }}</span>
          </el-form-item>
          <el-form-item label="籍贯:" prop="jiguan">
            <el-input v-model="basicInfo.jiguan" v-if="seen"></el-input>
            <span style="margin-left: 10px" v-else>{{ basicInfo.jiguan }}</span>
          </el-form-item>
          <el-form-item label="户籍地址:" prop="hujidizhi">
            <el-input v-model="basicInfo.hujidizhi" v-if="seen"></el-input>
            <span style="margin-left: 10px" v-else>{{ basicInfo.hujidizhi }}</span>
          </el-form-item>
          <el-form-item label="居住地址:" prop="juzhudizhi">
            <el-input v-model="basicInfo.juzhudizhi" v-if="seen"></el-input>
            <span style="margin-left: 10px" v-else>{{ basicInfo.juzhudizhi }}</span>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handConfirmInfo()" v-if="seen">确认</el-button>
          <el-button @click="handleModefiy()" v-else>修改</el-button>
          <el-button @click="myindexDialogvVisablle = false">取 消</el-button>
        </span>
      </el-dialog>

    </el-header>
    <!--页面主体区域-->
    <el-container>
      <!--侧边栏菜单区域-->
      <el-aside width="300px">
        <el-menu :default-openeds="openeds" :default-active='selectIndex' router='true'>
          <template v-for="menu in menu_json">
            <el-submenu :index="menu.index" :key="menu.index" v-if="menu.children != null">
              <template slot="title"><i :class="menu.icon"></i>{{ menu.name }}</template>
              <template v-for="menu2 in menu.children">
                <el-submenu :index="menu2.index" :key="menu2.index" v-if="menu2.children != null">
                  <template slot="title"><i :class="menu2.icon"></i>{{ menu2.name }}</template>
                  <template v-for="menu3 in menu2.children">
                    <el-submenu :index="menu3.index" :key="menu3.index" v-if="menu3.children != null">
                      <template slot="title"><i :class="menu3.icon"></i>{{ menu3.name }}</template>
                    </el-submenu>
                    <el-menu-item :index="menu3.index" :key="menu3.index" v-else>{{ menu3.name }}</el-menu-item>
                  </template>
                </el-submenu>
                <el-menu-item :index="menu2.index" :key="menu2.index" v-else>{{ menu2.name }}</el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item :index="menu.index" :key="menu.index" v-else>{{ menu.name }}</el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script >
import { getCurrentRoles, getUser, updateCurrentUser } from "../../utils/api";

let menu_admin = {
  index: 'admin',
  icon: 'el-icon-user-solid',
  name: '管理员权限',
  children: [],
};
let menu_teacher = {
  index: 'teacher',
  icon: 'el-icon-user-solid',
  name: '联系党员老师权限',
  children: [],
};
let menu_GLstudent = {
  index: 'GLstudent',
  icon: 'el-icon-user-solid',
  name: '组织委员权限',
  children: [],
};
let menu_jjfz = {
  index: 'kkfz',
  icon: 'el-icon-user-solid',
  name: '发展对象权限',
  children: [],
};


export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入新密码"));
      } else if (value.toString().length < 6 || value.toString().length > 18) {
        callback(new Error("密码长度为6 - 18个字符"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.resetForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      //重置密码
      resetForm: {
        password: "",
        renewpwd: "",
      },
      resetFormRules: {
        password: [{ required: true, validator: validatePass }],
        renewpwd: [{ required: true, validator: validatePass2 }],
      },
      navList: {},
      //个人信息修改对话框
      myindexDialogvVisablle: false,
      basicInfo: {
        username:'',
        fullName: '',
        sex: '',
        minzu: '',
        mobile: '',
        banji:'',
        birth:'',
        identity:'',
        jiguan:'',
        hujidizhi:'',
        juzhudizhi:''
      

      },
      seen: false,
      dialogVisible: false,
      userList: [],
      count: 1,
      loading: false,
      passWord: "",
      //导航菜单高亮
      activeIndex: "/SynQuery",
      openeds: [],
      selectIndex: name,
      menu_json: [{
        index: '/welcome',
        icon: 'el-icon-s-home',
        name: '首页',
        // children: [{
        //   index: 'homepage',
        //   name: '欢迎页'
        // }]
      }],

    };
  },
  created() {

    this.mygetCurrentRoles();
    this.info();
  },
  mounted() {
    this.activeIndex = this.$route.path;
  },

  computed: {
    noChildren() {
      return this.navList.filter((item) => !item.children);
    },
    hasChildren() {
      return this.navList.filter((item) => item.children);
    },
  },
  methods: {
    //获取到当前登录信息
    info() {
      getUser().then(result => {
        if (result.code === '0000') {
          this.basicInfo.username = result.data.username;
          this.basicInfo.fullName = result.data.fullName;
          this.basicInfo.mobile = result.data.mobile;
          this.basicInfo.banji = result.data.banji;
          this.basicInfo.birth = result.data.birth;
          this.basicInfo.identity = result.data.identity;
          this.basicInfo.jiguan = result.data.jiguan;
          this.basicInfo.hujidizhi = result.data.hujidizhi;
          this.basicInfo.juzhudizhi = result.data.juzhudizhi;
        }
      })
    },
    //退出登录
    logout() {
      this.$router.push('/login');
    },


    //获取到当前角色
    mygetCurrentRoles() {
      getCurrentRoles().then(result => {
        console.log(result);
        const _this = this;
        if (result.code === '0000') {
          result.data.forEach(function (item) {
            if (item.role === 'admin') {
              _this.menu_json.push(menu_admin);
              menu_admin.children.push({
                index: '/userlist',
                name: '用户管理'
              }, {
                index: '/rolelist',
                name: '角色名单'
              }, {
                index: '/userscore',
                name: '量化考核分数'
              },{
                index: '/adminActivity',
                name: '考核活动列表'
              });
            } else if (item.role === '党员联系老师') {

              _this.menu_json.push(menu_teacher);
              menu_teacher.children.push({
                index: '/xslist',
                name: '名单管理'
              }, {
                index: '/xsactivity',
                name: '量化考核管理'
              });
            } else if (item.role === '组织委员') {

              _this.menu_json.push(menu_GLstudent);
              menu_GLstudent.children.push({
                index: '/zzwyList',
                name: '名单管理'
              }, {
                index: '/zzwyActivity',
                name: '量化考核管理'
              });
            } else if (item.role === '入党积极分子') {

              _this.menu_json.push(menu_jjfz);
              menu_jjfz.children.push( {
                index: '/base',
                name: '基本信息'
              },
                {
                index: '/wxy',
                name: '微心愿'
              }, {
                index: '/wxd',
                name: '微行动'
              }, {
                index: '/wxf',
                name: '微学分'
              }, {
                index: '/wcz',
                name: '微成长'
              },{
                index: '/wfw',
                name: '微服务'
              });
            }
          })
        } else {
          console.log(result)
        }
      })
    },
    handleModefiy() {
      this.seen = !this.seen;

    },
    handConfirmInfo() {
      updateCurrentUser(this.basicInfo).then(result => {
        if (result.code === '0000') {
          this.$message.success(result.message);
          this.seen = !this.seen;
          this.myindexDialogvVisablle = false;
        }
      })

    },

    // async changePassword() {
    //   this.$refs.resetForm.validate(async (valid) => {
    //     if (!valid) return;
    //     const _this = this;
    //     const result = await yqhPost("/changepassword", _this.resetForm);
    //     if (!result.isSuccess) {
    //       this.$message.error(result.errorMsg);
    //     } else this.$message.success(result.errorMsg);
    //     this.dialogVisible = false;
    //   });
    // },
    // changePasswordDialog() {
    //   this.$refs.resetForm.resetFields();
    // },


  },
};
</script>

<style lang="less" scoped>
body {
  margin: 0;
}

.home-container {
  height: 100%;
}

.el-header {
  background-color: #CC1C1E;
  color: #ffffff;
  line-height: 70px;
  height: 70px;
}
.header_container{
  display: flex;
	justify-content: start;
	align-items: center;
  float: left;
}
.header_container img {

	width: 40px;
  margin-right: 20px;
}


.el-aside {
  background-color:#CC1C1E ;
  color: #E03032;
  height: calc(100vh - 70px);
}

.el-main {
  height: calc(100vh - 70px);

}

/deep/.el-menu .el-menu-item:hover{
    outline: 0 !important;
    color: #f39c12 !important;
    background: #E03032!important;
}
/deep/.el-menu .el-menu-item.is-active {
    color: #f39c12 !important;
    background: #E03032;
}


//设置选鼠标指针浮动在一级菜单的设置
.el-menu-item:hover{
  background-color: aqua !important;;
}
//设置当前被选中的一级菜单
.el-menu-item.is-active {  
  color: #fff !important;  
  background: #f20c00 !important;  
}

 .el-menu-item {
  font-size: 16px;
  background-color:#CC1C1E !important ;
  color: #fff!important;

}

.el-submenu /deep/ .el-submenu__title:hover {
  background-color: #CC1C1E !important;
  color: #fff!important;
}

.el-submenu /deep/ .el-submenu__title {
  background-color: #CC1C1E !important;
  color: #fff!important;
  font-size: 20px;
  }
.el-input {
  margin-right: 30px;
}
</style>